module.exports = global["$"] = require("-!/start/assets/node_modules/jquery/dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?$!./~/jquery/dist/jquery.js
 ** module id = 24
 ** module chunks = 12 13 15 16 18 19 20 21 22 23 24 25 26 28 29 30 31 32 33 34 36 37
 **/